import ContentCopyRounded from "@mui/icons-material/ContentCopyRounded";
import ReplayRounded from "@mui/icons-material/ReplayRounded";
import { IconButton } from "@mui/material";
import PrevNextPaginator from "src/components/general/PrevNextPaginator/PrevNextPaginator";
import type { MessageBubbleFooterProps } from "./MessageBubbleFooter.types";

export default function MessageBubbleFooter({
  isAi,
  isStreaming = false,
  showRetryButton = false,
  branchInfo,
  onSwitchBranch,
  onRetry,
  onCopy,
}: MessageBubbleFooterProps) {
  const showBranchNav =
    isAi && !isStreaming && onSwitchBranch && branchInfo && branchInfo.total > 1;

  return (
    <div className="flex items-center justify-end gap-1">
      {showBranchNav && (
        <PrevNextPaginator
          current={branchInfo.position - 1}
          pagesCount={branchInfo.total}
          onChange={(index) =>
            onSwitchBranch(index < branchInfo.position - 1 ? -1 : 1)
          }
          iconSize={18}
          className="gap-0 text-text-secondary"
          slotProps={{
            prevIconButton: {
              size: "small",
              title: "Previous response",
              "data-ph-capture-attribute-action": "switch_ai_branch_prev",
              sx: { padding: "2px" },
            },
            nextIconButton: {
              size: "small",
              title: "Next response",
              "data-ph-capture-attribute-action": "switch_ai_branch_next",
              sx: { padding: "2px" },
            },
          }}
        >
          <span
            className="text-xs tabular-nums select-none"
            data-test-id="ai-branch-nav"
          >
            {branchInfo.position} / {branchInfo.total}
          </span>
        </PrevNextPaginator>
      )}
      {isAi && !isStreaming && onCopy && (
        <IconButton
          size="small"
          onClick={onCopy}
          title="Copy response"
          data-ph-capture-attribute-action="copy_ai_response"
          className="ml-1 transition-opacity hover:text-text-primary"
          sx={{ padding: "4px" }}
        >
          <ContentCopyRounded sx={{ fontSize: 16 }} />
        </IconButton>
      )}
      {showRetryButton && onRetry && !isStreaming && (
        <IconButton
          size="small"
          onClick={onRetry}
          title="Retry"
          data-ph-capture-attribute-action="retry_ai_message"
          className="transition-opacity hover:text-text-primary"
          sx={{ padding: "4px" }}
        >
          <ReplayRounded sx={{ fontSize: 16 }} />
        </IconButton>
      )}
    </div>
  );
}
